import {
  LocalStorageKey,
  SessionService,
} from './../core/services/session.service';
import { Observable, Observer } from 'rxjs';
import { CompletedataService } from '@techrules/portallib';
import { Injectable } from '@angular/core';

export enum OnboardingNextactionEnum {
  TO_PROFILE = 'to_profile',
  TO_FUNDING = 'to_funding',
  TO_FINALIZE = 'to_finalize',
}

export interface OnboardingRedirectorInterface {
  onboardingNextAction: string;
  portfolioCode: string;
  clientName: string;
  clientSurname: string;
  servicemodelcode: string;
}

@Injectable()
export class OnboardingRedirector {
  constructor(
    private service: CompletedataService,
    private session: SessionService
  ) {}

  public redirect(info: OnboardingRedirectorInterface): Observable<string> {
    return new Observable((observer: Observer<string>) => {
      let url = '';
      switch (info.onboardingNextAction) {
        case OnboardingNextactionEnum.TO_PROFILE:
          /*
          localStorage.setItem('Profile', 'Portfolio');
          localStorage.setItem('OnboardingPortfolio', info.portfolioCode);
          localStorage.setItem('ServiceModelCode', info.servicemodelcode);
          */
          this.session.profile = 'Portfolio';
          this.session.onboardingPortfolio = info.portfolioCode;
          this.session.serviceModelCode = info.servicemodelcode;

          url = '/questionnaire';
          observer.next(url);
          observer.complete();
          break;
        case OnboardingNextactionEnum.TO_FUNDING:
          /*
          localStorage.removeItem('Profile');
          localStorage.setItem('OnboardingPortfolio', info.portfolioCode);
          */
          this.session.removeItem(LocalStorageKey.PROFILE);
          this.session.onboardingPortfolio = info.portfolioCode;
          url = '/datacollection/funding';
          observer.next(url);
          observer.complete();
          break;
        case OnboardingNextactionEnum.TO_FINALIZE:
          //- llama a apirest/portal/portfolio/{PortfolioCode}/onboarding
          this.service
            .finalizeOnboarding(
              info.clientName + ' ' + info.clientSurname,
              info.portfolioCode
            )
            .subscribe(() => {
              /*
              localStorage.removeItem('Profile');
              localStorage.removeItem('OnboardingPortfolio');
              */
              this.session.removeItem(LocalStorageKey.PROFILE);
              this.session.removeItem(LocalStorageKey.ONBOARDING_PORTFOLIO);
              url = '/portfolios';
              observer.next(url);
              observer.complete();
            });
          break;
      }
    });
  }
}
